import { styled } from "@mui/material";

import { DefaultText } from "./DefaultText";

export const StudentName = styled(DefaultText)(() => ({
  textDecoration: "underline",
  flexBasis: "calc(100% / 4 - 1rem)",
  cursor: "pointer",
}));
